import script from "./Multiselect.vue?vue&type=script&setup=true&lang=js"
export * from "./Multiselect.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./Multiselect.vue?vue&type=style&index=1&id=644c5e8a&lang=scss"

const __exports__ = script;

export default __exports__